<template>
  <div class="contacts">
    <div class="page_content">
      <div class="lines">
        <div class="lines_block"></div>
        <div class="lines_block"></div>
      </div>
      <div class="contacts_content">
        <div class="contacts_block title-fade">
          <h3 class="contacts_title">Для клиентов</h3>
          <a href="mailto:detali@anturium.agency" class="contacts_link">detali@anturium.agency</a>
        </div>
        <div class="contacts_block subtitle-fade">
          <h3 class="contacts_title">Для сотрудничества</h3>
          <a href="mailto:co-work@anturium.agency" class="contacts_link">co-work@anturium.agency</a>
        </div>
      </div>
    </div>
    <Form/>
  </div>
</template>

<script>
import Form from 'components/form/Form';

export default {
  components: {
    Form,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/contacts/Contacts.vue